import { get, postJson } from '../httpClient';

/**
 * Episode RSVPs — "Reserve my spot".
 *
 * `summary` returns every episode's count for a Live Room plus which ones the
 * current member has reserved; `toggle` flips one; `attendees` returns the
 * avatar stack for a single episode (identities only for a viewer entitled to
 * them — see server/api-util/episodeRsvp.js).
 */
export const episodeRsvpAPI = {
  summary: listingId => get(`/api/episodes/${listingId}/rsvp`),

  toggle: (listingId, episodeId) =>
    postJson(`/api/episodes/${listingId}/${episodeId}/rsvp`, {}),

  // Mark the current member's spot as reserved, without ever releasing it.
  reserve: (listingId, episodeId) =>
    postJson(`/api/episodes/${listingId}/${episodeId}/rsvp`, { reserved: true }),

  attendees: (listingId, episodeId) =>
    get(`/api/episodes/${listingId}/${episodeId}/attendees`),

  // Move an episode to a new time; its id, reservations and chat carry over.
  reschedule: (listingId, episodeId, { start, end }) =>
    postJson(`/api/episodes/${listingId}/${episodeId}/reschedule`, { start, end }),

  // The signed-in member's own reserved episodes, for their calendar.
  mine: () => get('/api/episodes/mine'),
};
